import { useEffect, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";
import { getProjectTemplates } from "src/redux";
import { RootState } from "src/redux/reducers";
import {
  getProjectTemplateOptions,
  updateProjectTemplatesWithAITemplates,
} from "../utils";
import { ProjectTemplateType } from "src/redux/project/types";
import { CampaignTemplate } from "src/types";

export default function useGetTemplates(aiTemplates: CampaignTemplate[]) {
  const dispatch = useDispatch();

  const { activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const { projectTemplates } = useSelector(
    (state: RootState) => state.projectReducer,
  );

  const updatedProjectTemplates = useMemo(
    () => updateProjectTemplatesWithAITemplates(projectTemplates, aiTemplates),
    [projectTemplates, aiTemplates],
  );

  const allSocialPlatformTemplateOptions = useMemo(
    () =>
      getProjectTemplateOptions(
        updatedProjectTemplates,
        ProjectTemplateType.SocialProvider,
      ),
    [updatedProjectTemplates],
  );

  const allBaseOptions = useMemo(
    () =>
      getProjectTemplateOptions(
        updatedProjectTemplates,
        ProjectTemplateType.Base,
      ),
    [updatedProjectTemplates],
  );

  useEffect(() => {
    dispatch(getProjectTemplates(activeWorkspaceUuid));
  }, [dispatch, activeWorkspaceUuid]);

  return {
    allSocialPlatformTemplateOptions,
    allBaseOptions,
    updatedProjectTemplates,
  };
}
